import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Swal from "sweetalert2";
import config from "../../config";

function SpecialExamUploadnotice12() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [showingDate, setShowingDate] = useState("");

    const noticeFileRef = useRef();
    const [noticeFilePdf, setNoticeFilePdf] = useState("");
    const [noticeFileName, setNoticeFileName] = useState("");
    const [noticePreviewUrl, setNoticePreviewUrl] = useState("");

    const [markAsNewCheck, setMarkAsNewCheck] = useState("NO");
    const [description, setDescription] = useState("");
    const [noticeList, setNoticeList] = useState([]);
    const [editId, setEditId] = useState("");

    const token = sessionStorage.getItem("intermediateAdminToken");

    const fetchNotices = async () => {
        setLoading(true);
        try {
            const response = await fetch(
                `${config.API_BASE_URL2}/CSExamAdminFetchNoticeData_CL12`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const data = await response.json();
            if (Array.isArray(data.data.noticeData_list)) {
                setNoticeList(data.data.noticeData_list);
            } else {
                setNoticeList([]);
            }
        } catch (error) {
            console.error("Error fetching notice list:", error);
            setNoticeList([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!token) {
            navigate("/intermediate-admin");
        } else {
            fetchNotices();
        }
        document.body.classList.add("sidebar-icon-only");
        return () => {
            document.body.classList.remove("sidebar-icon-only");
        };
    }, []);

    const validateForm = () => {
        if (!showingDate) {
            Swal.fire("Required  Field", "Please select a date", "warning");
            return false;
        }
        if (!noticeFileName || !noticePreviewUrl) {
            Swal.fire("Required  Field", "Please upload a notice file", "warning");
            return false;
        }
        if (!description.trim()) {
            Swal.fire("Required  Field", "Description is required", "warning");
            return false;
        }
        return true;
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        if (noticeFileRef.current) noticeFileRef.current.value = "";
        if (!file) return;

        if (file.type !== "application/pdf" && noticeFileRef.current) {
            noticeFileRef.current.value = "";
            Swal.fire("Warning", "Only PDF files are allowed!", "warning");
            return;
        }
        if (file.size > 1024 * 1024) {
            console.log("File too large:", file.size, "bytes");
            noticeFileRef.current.value = "";
            Swal.fire("Warning", "File size must be less than 1 MB!", "warning");
            return;
        }

        reader.onloadend = () => {
            const base64 = reader.result;
            setNoticeFilePdf(file);
            setNoticeFileName(file.name);
            const objectUrl = URL.createObjectURL(file);
            setNoticePreviewUrl(objectUrl);
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        try {
            const payload = new FormData();
            payload.append("ID", editId || 0);
            payload.append("DEO", "");
            payload.append("PRINCIPLE", "");
            payload.append("DESCRIPTION", description);
            payload.append("NEW_MARKING", markAsNewCheck || "NO");
            payload.append("NOTICE_FILE", noticeFileName || "");
            payload.append("UPDATE_BY", sessionStorage.getItem("schoolCode") || "");
            payload.append(
                "SHOWING_DATE",
                showingDate.split("-").reverse().join("-")
            );
            payload.append(
                "NOTICE_FILE_PDF",
                noticeFilePdf === null ? "" : noticeFilePdf
            );

            for (var pair of payload.entries()) {
                console.log(pair[0] + ": " + pair[1]);
            }

            const response = await fetch(
                `${config.API_BASE_URL2}/CSExamAdminInsertUpdatedNoticeData_CL12`,
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: payload,
                }
            );

            if (response.ok) {
                Swal.fire(
                    "Success",
                    `Notice ${editId ? "updated" : "uploaded"} successfully!`,
                    "success"
                ).then(() => {
                    fetchNotices();
                });
                resetForm();
            } else {
                const data = await response.json();
                Swal.fire(
                    "Warning",
                    data.data.message || "Failed to upload notice",
                    "warning"
                );
            }
        } catch (error) {
            console.error("Error:", error);
            Swal.fire("Warning", "An error occurred while uploading", "warning");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = async (id) => {
        setLoading(true);
        try {
            const response = await fetch(
                `${config.API_BASE_URL2}/AdminEditNoticeDataIntermediate`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ id }),
                }
            );
            const data = await response.json();

            if (response.ok && data.data.editNotice_data) {
                const notice = data.data.editNotice_data;
                setEditId(notice.id || "");
                setShowingDate(notice.showinG_DATE || "");
                setMarkAsNewCheck(notice.neW_MARKING || "NO");
                setNoticeFileName(notice.noticE_FILE || "");
                setDescription(notice.noticE_DESCRIPTION || "");
                setNoticePreviewUrl(notice.noticE_FILE_URL || "");
            } else {
                Swal.fire("Warning", "Failed to fetch notice for edit", "warning");
            }
        } catch (error) {
            Swal.fire(
                "Warning",
                "An error occurred while fetching notice for edit",
                "warning"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this notice?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                setLoading(true);
                try {
                    const response = await fetch(
                        `${config.API_BASE_URL2}/AdminDeleteNoticeDataIntermediate`,
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({ id }),
                        }
                    );

                    if (response.ok) {
                        Swal.fire(
                            "Success",
                            "Notice deleted successfully!",
                            "success"
                        ).then(() => {
                            fetchNotices();
                        });
                        resetForm();
                    } else {
                        Swal.fire("Warning", "Failed to delete notice", "warning");
                    }
                } catch (error) {
                    Swal.fire("Warning", "An error occurred while deleting", "warning");
                } finally {
                    setLoading(false);
                }
            }
        });
    };

    const resetForm = () => {
        setEditId("");
        setShowingDate("");
        setDescription("");
        setNoticeFileName("");
        setMarkAsNewCheck("NO");
        setNoticePreviewUrl("");
        const fileInput = document.getElementById("noticeFileInput");
        if (fileInput) fileInput.value = "";
    };

    return (
        <>
            {loading && (
                <div className="custom-loader-container">
                    <div className="custom-loader"></div>
                </div>
            )}
            <div class="container-scroller">
                <Navbar />
                <div class="container-fluid page-body-wrapper">
                    <Sidebar />
                    <div class="main-panel">
                        <div class="content-wrapper">
                            <div className="row">
                                <div className="col-md-12 mb-2">
                                    <section className="content-header">
                                        <h1>
                                            <i className="fa fa-file" />
                                            &nbsp;Upload Notice Class XII (Special Exam)
                                        </h1>
                                        <ol className="breadcrumb">
                                            <li>
                                                <a
                                                    onClick={() =>
                                                        navigate("/intermediate-admin-dashboard")
                                                    }
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <i
                                                        className="fa fa-tachometer"
                                                        style={{ marginRight: "5px" }}
                                                    ></i>{" "}
                                                    Home
                                                </a>
                                            </li>
                                            <li className="active">
                                                Intermediate Admin Upload Notice Class XII (Special Exam)
                                            </li>
                                        </ol>
                                        <h3 />
                                    </section>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4 mb-3 ">
                                    <div className="card">
                                        <div className="card-header bg-green">
                                            <h5 className="mb-0 p-2">Upload Notice</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>
                                                            Date <span className="text-danger">*</span>
                                                        </label>
                                                        {/* <input type="date" className="form-control form-control-sm" value={showingDate}
                                                            onChange={(e) => setShowingDate(e.target.value)}
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        /> */}
                                                        <DatePicker
                                                            selected={
                                                                showingDate
                                                                    ? new Date(
                                                                        showingDate.split("-").reverse().join("-")
                                                                    )
                                                                    : null
                                                            }
                                                            onChange={(date) => {
                                                                const day = String(date.getDate()).padStart(
                                                                    2,
                                                                    "0"
                                                                );
                                                                const month = String(
                                                                    date.getMonth() + 1
                                                                ).padStart(2, "0");
                                                                const year = date.getFullYear();
                                                                setShowingDate(`${day}-${month}-${year}`);
                                                            }}
                                                            dateFormat="dd-MM-yyyy"
                                                            className="form-control form-control-sm"
                                                            placeholderText="dd-mm-yyyy"
                                                            onKeyDown={(e) => e.preventDefault()}
                                                            showYearDropdown
                                                            scrollableYearDropdown
                                                            yearDropdownItemNumber={60}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>
                                                            Notice File
                                                            <span className="text-danger">*</span>&nbsp;
                                                            <small
                                                                className="text-muted"
                                                                style={{ fontSize: "0.75rem", fontWeight: 500 }}
                                                            >
                                                                (Type:PDF | Size:1 MB)
                                                            </small>
                                                        </label>
                                                        <input
                                                            ref={noticeFileRef}
                                                            type="file"
                                                            accept="application/pdf"
                                                            name="noticeFileInput"
                                                            id="noticeFileInput"
                                                            className="d-none"
                                                            onChange={(e) => handleFileChange(e)}
                                                        />
                                                        <div className="d-flex align-items-center">
                                                            <label
                                                                htmlFor="noticeFileInput"
                                                                className="custom-file-uploader btn btn-sm btn-outline-primary"
                                                                style={{
                                                                    width: "220px",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                <i className="fa fa-upload"></i> &nbsp;
                                                                {noticePreviewUrl
                                                                    ? noticeFileName
                                                                        ? noticeFileName
                                                                        : "Choose File"
                                                                    : "Choose File"}
                                                            </label>
                                                            {noticePreviewUrl && (
                                                                <a
                                                                    href={noticePreviewUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-secondary ms-2 eyeicon"
                                                                    title="Preview Notice"
                                                                    style={{
                                                                        height: "40px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    👁️
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <input
                                                            className="form-check-input ms-3"
                                                            type="checkbox"
                                                            id="newCheckbox"
                                                            style={{ border: "1px solid gray" }}
                                                            checked={markAsNewCheck === "YES"}
                                                            onChange={(e) =>
                                                                setMarkAsNewCheck(
                                                                    e.target.checked ? "YES" : "NO"
                                                                )
                                                            }
                                                        />
                                                        &nbsp;
                                                        <label
                                                            className="form-check-label ms-1"
                                                            htmlFor="newCheckbox"
                                                        >
                                                            Mark As New
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12">
                                                    <div className="form-group mb-3">
                                                        <label>
                                                            Description <span className="text-danger">*</span>
                                                        </label>
                                                        <textarea
                                                            className="form-control form-control-sm"
                                                            rows={5}
                                                            placeholder="Enter Description"
                                                            value={description}
                                                            onChange={(e) => setDescription(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-2"
                                                    onClick={() => {
                                                        resetForm();
                                                    }}
                                                    disabled={loading}
                                                >
                                                    <i className="fa fa-times"></i>&nbsp;Cancel
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success"
                                                    onClick={handleSubmit}
                                                    disabled={loading}
                                                >
                                                    <i className="fa fa-save"></i>&nbsp;
                                                    {loading ? "Saving..." : "Save"}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8 mb-3">
                                    <div className="card">
                                        <div className="card-header bg-green">
                                            <h5 className="mb-0 p-2">Notice List</h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>#</th>
                                                            <th>Date</th>
                                                            <th>File View</th>
                                                            <th>Mark As New</th>
                                                            <th>Description</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {noticeList.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="7" className="text-center">
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        ) : (
                                                            noticeList.map((notice, index) => (
                                                                <tr key={notice.id || index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{notice.showinG_DATE}</td>
                                                                    <td>
                                                                        {notice.noticE_FILE ? (
                                                                            <a
                                                                                href={
                                                                                    notice.noticE_FILE_URL
                                                                                        ? notice.noticE_FILE_URL
                                                                                        : `${process.env.PUBLIC_URL}/assets/images/no-image.png`
                                                                                }
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                className="btn btn-link p-0"
                                                                            >
                                                                                {notice.noticE_FILE}
                                                                            </a>
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {notice.neW_MARKING === "YES" ? (
                                                                            <span className="badge bg-success">
                                                                                YES
                                                                            </span>
                                                                        ) : (
                                                                            <span className="badge bg-danger">
                                                                                NO
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {notice.noticE_DESCRIPTION ||
                                                                            notice.noticE_DESCRIPTION ||
                                                                            "-"}
                                                                    </td>
                                                                    <td
                                                                        style={{
                                                                            width: "150px",
                                                                            alignItems: "center",
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className="btn btn-xs btn-primary me-2"
                                                                            type="button"
                                                                            onClick={() => handleEdit(notice.id)}
                                                                        >
                                                                            <i className="fa fa-edit me-2"></i>Edit
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-xs btn-danger"
                                                                            type="button"
                                                                            onClick={() => handleDelete(notice.id)}
                                                                        >
                                                                            <i className="fa fa-trash me-2"></i>Delete
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </>
    );
}

export default SpecialExamUploadnotice12;
